import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import styles from './BackButton.module.css';

const BackButton = () => {
    const navigate = useNavigate();
    return (
        <button onClick={() => navigate(-1)} className={styles.backButton}>
            <ChevronLeft size={18} />
            Back
        </button>
    );
};

export default BackButton;